import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAresSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_d_9257_959)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 2,
				width: 42,
				height: 42,
				rx: 5.25,
				fill: "#0E293E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.7558 23.4933C16.7558 18.3566 20.9397 14.2315 26.0533 14.2315C30.1108 14.2315 33.5339 16.7992 34.8004 20.4199C33.745 16.1256 29.8569 12.9256 25.208 12.9256C19.7565 12.9256 15.319 17.3036 15.319 22.7776C15.319 27.9984 19.3761 32.2507 24.5318 32.5875C20.1367 31.8718 16.7558 28.0826 16.7558 23.4933Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M33.3214 11.4095C30.9138 9.72562 25.3348 13.3889 20.8975 19.5771C16.4178 25.8091 14.7697 32.2507 17.1784 33.9348C19.5873 35.661 25.1657 31.9981 29.603 25.7669C34.0402 19.5359 35.7304 13.1359 33.3214 11.4095ZM28.5888 25.0091C24.5318 30.6929 19.5873 34.1032 17.5588 32.6717C15.5303 31.2403 17.1784 25.4721 21.2777 19.7889C25.3348 14.105 30.2363 10.6521 32.2659 12.1256C34.2941 13.5565 32.6453 19.3256 28.5888 25.0091Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.2503 12.883C19.7565 12.883 15.319 17.3036 15.319 22.7776C15.319 28.251 19.7565 32.6718 25.2503 32.6718C30.7441 32.6718 35.1813 28.251 35.1813 22.7776C35.1813 17.3036 30.7441 12.883 25.2503 12.883ZM25.7575 32.1665C20.8129 32.1665 16.8404 28.1667 16.8404 23.2829C16.8404 18.3566 20.8129 14.3992 25.7575 14.3992C30.6599 14.3992 34.6749 18.3566 34.6749 23.2829C34.6749 28.1667 30.6599 32.1665 25.7575 32.1665Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_9257_959",
		x: 0,
		y: 0,
		width: 50,
		height: 50,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_9257_959"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_9257_959",
				result: "shape"
			})
		]
	}) })]
});
export default SvgAresSm;
